import browserUtils from '../../browser';

const clearFormData = (name: string) => (browserUtils.getWindow() as any).sessionStorage.removeItem(name);

export default clearFormData;
